import { render } from "./LeaderboardUserElement.vue?vue&type=template&id=0f4caf3c&scoped=true"
import script from "./LeaderboardUserElement.vue?vue&type=script&lang=js"
export * from "./LeaderboardUserElement.vue?vue&type=script&lang=js"

import "./LeaderboardUserElement.vue?vue&type=style&index=0&id=0f4caf3c&scoped=true&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-0f4caf3c"]])

export default __exports__